(($) => {
    $.inherit = (function () {
        function intermediate() { }

        return function (child, parent) {
            intermediate.prototype = parent.prototype;
            child.prototype = new intermediate;
            child.prototype.constructor = child;
            child.superproto = parent.prototype;
            return child;
        };
    })();
})(jQuery);